import MultiSelectDropdown from "layouts/component/MultiSelectDropdown";
import targetting from "layouts/constant/targetting";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  FormGroup,
  Input,
  Button,
  Form,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CustomInput,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import { createAnsUpdateTargetting } from "service/offerTarget.service";

const Step5Form = ({
  formData,
  handleOfferChange,
  handleNextStep,
  handlePreviousStep,
}) => {
  const [offerData, setFormData] = useState({
    location: {
      city: "",
      state: "",
    },
    age: "",
    gender: "",
    isLocationTargetting: false,
    isDemographicTargetting: false,
  });
  const [redirectTo, setRedirect] = useState("live");

  // useEffect(() => {
  //     fetchOfferTypes();
  //     fetchOfferStatus();
  //     console.log(formData);
  //     setFormData((prevData) => ({
  //         ...prevData,
  //         ...formData
  //     }));
  //     setTags(formData.offer_tags);
  //     if (formData.offer_badges.length > 0) {
  //         setBadges(formData.offer_badges[0]);
  //     }
  //     if (formData.id > 0) {
  //         fetchOfferById(formData.id);
  //     }

  //     setSelectedOfferStatus(formData.status);

  // }, [formData]);

  console.log(formData.id);

  useEffect(() => {
    setAllowedCountries(["IN"]);
  }, [formData]);

  const countryOptions = targetting.countryOptions;
  const stateOptions = targetting.stateOptions;
  const cityOptions = targetting.cityOptions;

  const [allowedCountries, setAllowedCountries] = useState([]);
  const [disallowedCountries, setDisallowedCountries] = useState([]);
  const [allowedStates, setAllowedStates] = useState([]);
  const [disallowedStates, setDisallowedStates] = useState([]);
  const [allowedCities, setAllowedCities] = useState([]);
  const [disallowedCities, setDisallowedCities] = useState([]);

  const queryParams = new URLSearchParams(window.location.search);

  // Access a specific query parameter value by its name
  const paramValue = queryParams.get("from");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleLocationChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      location: {
        ...prevFormData.location,
        [name]: value,
      },
    }));
  };

  const handleLocationRemove = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      location: {
        city: "",
        state: "",
      },
    }));
  };

  const handleRoute = () => {};

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = {
      includeCountry: allowedCountries,
      excludeCountry: disallowedCountries,
      includeState: allowedStates,
      excludeState: disallowedStates,
      includeCity: allowedCities,
      excludeCity: disallowedCities,
      offerId: formData.id,
    };

    console.log(data);

    try {
      const result = await createAnsUpdateTargetting(data);
      console.log(result);
    } catch (error) {
      console.log(error);
    }
  };

  const {
    location,
    age,
    gender,
    isLocationTargetting,
    isDemographicTargetting,
  } = offerData;

  return (
    <>
      <div>
        <h4 className="mb-0"> Audience Targeting </h4>{" "}
      </div>{" "}
      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <CustomInput
            type="switch"
            id="isLocationTargetting"
            name="isLocationTargetting"
            label="Enable Location Targeting"
            checked={isLocationTargetting}
            onChange={() =>
              setFormData((prevFormData) => ({
                ...prevFormData,
                isLocationTargetting: !prevFormData.isLocationTargetting,
              }))
            }
          />{" "}
        </FormGroup>{" "}
        {
          <>
            <Row className="m-3">
              <fieldset className="custom-fieldset">
                <legend className="custom-legend"> Country </legend>{" "}
                <Col>
                  <Row>
                    <Col>
                      <FormGroup className="w-100">
                        <label htmlFor="allowed"> Include: </label>{" "}
                        <MultiSelectDropdown
                          options={countryOptions}
                          setData={setAllowedCountries}
                          className="w-100"
                        />{" "}
                        {allowedCountries && (
                          <div style={{ marginTop: 20, lineHeight: "25px" }}>
                            <div>
                              {" "}
                              <b> Selected Options: </b>{" "}
                              {JSON.stringify(allowedCountries, null, 2)}{" "}
                            </div>{" "}
                          </div>
                        )}{" "}
                      </FormGroup>{" "}
                    </Col>{" "}
                  </Row>{" "}
                  <Row>
                    <Col>
                      <FormGroup>
                        <label htmlFor="disallowed"> Exclude: </label>{" "}
                        <MultiSelectDropdown
                          options={countryOptions}
                          setData={setDisallowedCountries}
                        />{" "}
                        {disallowedCountries && (
                          <div style={{ marginTop: 20, lineHeight: "25px" }}>
                            <div>
                              {" "}
                              <b> Selected Options: </b>{" "}
                              {JSON.stringify(disallowedCountries, null, 2)}{" "}
                            </div>{" "}
                          </div>
                        )}{" "}
                      </FormGroup>{" "}
                    </Col>{" "}
                  </Row>{" "}
                </Col>{" "}
              </fieldset>{" "}
            </Row>{" "}
            <Row className="m-3">
              <fieldset className="custom-fieldset">
                <legend className="custom-legend"> State </legend>{" "}
                <Col>
                  <Row>
                    <Col>
                      <FormGroup>
                        <label htmlFor="allowed"> Include: </label>{" "}
                        <MultiSelectDropdown
                          options={stateOptions}
                          setData={setAllowedStates}
                        />{" "}
                        {allowedStates && (
                          <div style={{ marginTop: 20, lineHeight: "25px" }}>
                            <div>
                              {" "}
                              <b> Selected Options: </b>{" "}
                              {JSON.stringify(allowedStates, null, 2)}{" "}
                            </div>{" "}
                          </div>
                        )}{" "}
                      </FormGroup>{" "}
                    </Col>{" "}
                  </Row>{" "}
                  <Row>
                    <Col>
                      <FormGroup>
                        <label htmlFor="disallowed"> Exclude: </label>{" "}
                        <MultiSelectDropdown
                          options={stateOptions}
                          setData={setDisallowedStates}
                        />{" "}
                        {disallowedStates && (
                          <div style={{ marginTop: 20, lineHeight: "25px" }}>
                            <div>
                              {" "}
                              <b> Selected Options: </b>{" "}
                              {JSON.stringify(disallowedStates, null, 2)}{" "}
                            </div>{" "}
                          </div>
                        )}{" "}
                      </FormGroup>{" "}
                    </Col>{" "}
                  </Row>{" "}
                </Col>{" "}
              </fieldset>{" "}
            </Row>{" "}
            <Row className="m-3">
              <fieldset className="custom-fieldset">
                <legend className="custom-legend"> City </legend>{" "}
                <Row>
                  <Col>
                    <Row>
                      <Col>
                        <FormGroup>
                          <label htmlFor="allowed"> Include: </label>{" "}
                          <MultiSelectDropdown
                            options={cityOptions}
                            setData={setAllowedCities}
                          />{" "}
                          {allowedCities && (
                            <div style={{ marginTop: 20, lineHeight: "25px" }}>
                              <div>
                                {" "}
                                <b> Selected Options: </b>{" "}
                                {JSON.stringify(allowedCities, null, 2)}{" "}
                              </div>{" "}
                            </div>
                          )}{" "}
                        </FormGroup>{" "}
                      </Col>{" "}
                    </Row>{" "}
                    <Row>
                      <Col>
                        <FormGroup>
                          <label htmlFor="disallowed"> Exclude: </label>{" "}
                          <MultiSelectDropdown
                            options={cityOptions}
                            setData={setDisallowedCities}
                          />{" "}
                          {disallowedCities && (
                            <div style={{ marginTop: 20, lineHeight: "25px" }}>
                              <div>
                                {" "}
                                <b> Selected Options: </b>{" "}
                                {JSON.stringify(disallowedCities, null, 2)}{" "}
                              </div>{" "}
                            </div>
                          )}{" "}
                        </FormGroup>{" "}
                      </Col>{" "}
                    </Row>{" "}
                  </Col>{" "}
                </Row>{" "}
              </fieldset>{" "}
            </Row>{" "}
            {location.allowed && location.disallowed && (
              <div>
                <span>
                  {" "}
                  Allowed: {location.allowed}, Disallowed: {location.disallowed}{" "}
                </span>{" "}
                <button type="button" onClick={handleLocationRemove}>
                  Remove{" "}
                </button>{" "}
              </div>
            )}{" "}
          </>
        }{" "}
        <div className="text-center mt-3">
          <Button type="submit"> Submit </Button>{" "}
        </div>{" "}
      </Form>{" "}
      <div className="half-height">
        <> </>{" "}
      </div>{" "}
    </>
  );
};

export default Step5Form;
